// TODO-KPI-03 — katalog → set bildirimli aktarım: `/api/v1/kpi/sets/:setId/catalog-sync` sarmalayıcıları.
// Durum (fark listesi + imza, kpi.view) ve uygula (seçili farklar, kpi.manage).

import type {
  KpiCatalogSyncApplyBody,
  KpiCatalogSyncApplyResult,
  KpiCatalogSyncStatus,
} from "@mahir/shared";
import { api } from "./client";

export async function getKpiCatalogSync(setId: string): Promise<KpiCatalogSyncStatus> {
  return api(`/kpi/sets/${setId}/catalog-sync`);
}

export async function applyKpiCatalogSync(
  setId: string,
  body: KpiCatalogSyncApplyBody,
): Promise<KpiCatalogSyncApplyResult> {
  return api(`/kpi/sets/${setId}/catalog-sync/apply`, { method: "POST", body });
}
